var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFbmessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1115 8.94868L15.6902 14.3458C15.1525 15.1724 13.9306 15.4155 13.1486 14.832L10.4115 12.7899C10.1671 12.5954 9.82499 12.5954 9.58061 12.7899L5.91487 15.5613C5.42611 15.9503 4.79071 15.3182 5.13285 14.832L8.60308 9.4349C9.14072 8.60832 10.3626 8.36521 11.1447 8.94868L13.8817 10.9908C14.1261 11.1853 14.4683 11.1853 14.7126 10.9908L18.3784 8.21934C18.7694 7.87898 19.4537 8.46245 19.1115 8.94868ZM12.0733 0.293884C5.47498 0.293884 0.39183 5.10751 0.39183 11.5743C0.39183 14.9292 1.80925 17.8466 4.05757 19.9374C4.25307 20.0832 4.35083 20.3263 4.35083 20.6181L4.3997 22.7088C4.44858 23.3895 5.08397 23.7785 5.67049 23.5354L7.96768 22.5143C8.16319 22.4171 8.3587 22.4171 8.5542 22.4657C9.58061 22.7575 10.7536 22.9033 11.9267 22.9033C18.525 22.9033 23.6082 18.0897 23.6082 11.6229C23.6082 5.15613 18.6716 0.293884 12.0733 0.293884Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbmessenger);
export default __webpack_public_path__ + "static/media/fbmessenger.8d6c5b38.svg";
export { ForwardRef as ReactComponent };